export default {
    //ChangeSubscriptionComponent
    info_promotional_coupon: '¿Tienes un cupón promocional? Haz click en "Activar" para usarlo. ',

    //CurrentSubscriptionComponent
    canceled_message: 'Su cuenta ha sido cancelada. Suscríbase a un plan para volver a activar su cuenta.',

    //StripeNumberComponent
    change_pay_method: 'Cambiar método de pago',

    //NavigationMyAccountComponent e InformationComponent
    subtitle: 'Verwalten Sie Ihr Profil, die Abrechnung und das Abonnement Ihrer Akademie.',
    sections: 'Bereiche von Mein Konto',
    profile_description: 'Persönliche Daten, Foto und Passwort',
    billing_details: 'Rechnungsdaten',
    billing_details_description: 'Steuerdaten und Bankkonto',
    my_subscription: 'Mein Abonnement',
    my_subscription_description: 'Aktueller Plan und Rechnungen',
    plans_description: 'Plan wechseln oder reaktivieren',
    my_academies: 'Meine Akademien',
    my_academies_description: 'Akademien in Ihrem Konto',
    about: 'Über',
    about_description: 'Version und Neuigkeiten',
    about_title: 'Informationen zur Anwendung',
    app_name: 'Anwendung',
    manufacturer: 'Hersteller',
    version: 'Version',
    changelog: 'Neuigkeiten',
    current_version: 'Aktuelle Version',
    show_less: 'Weniger anzeigen',
    show_full_history: 'Vollständigen Verlauf anzeigen ({count} weitere)',
    thanks: 'Danke für Ihr Vertrauen in BrainsPro. Wir verbessern die Plattform laufend; hier finden Sie die Neuigkeiten, sobald wir sie veröffentlichen.',
}
